<template>
  <ui-content title="Biblia">
    <Spinner v-if="loading.view"></Spinner>
    <template v-else>
      <ui-card title="Filtros" icon="fas fa-fw fa-filter">
        <div class="row">
          <div class="col-lg-3">
            <div class="form-group">
              <label for="" class="form-label">Servicio</label>
              <InputSelect v-model="servicio" :options="servicios" :clearable="false" :disabled="loading.biblias"></InputSelect>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <label for="" class="form-label">Fecha</label>
              <InputDatepicker v-model="fecha" :disabled="loading.biblias"> </InputDatepicker>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <label for="" class="form-label">Estado</label>
              <InputSelect v-model="estado" :options="estados" :clearable="false" :disabled="loading.biblias"></InputSelect>
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-lg-4">
            <p class="mb-1"><strong>Nro. de Biblias:</strong> {{ resumen.nroBiblias }}</p>
            <p class="mb-1"><strong>Registros:</strong> {{ resumen.registros }}</p>
            <p class="mb-1"><strong>Pendientes:</strong> {{ resumen.pendientes }}</p>
          </div>
          <div class="col-lg-4">
            <p class="mb-1"><strong>P. Total:</strong> {{ resumen.pTotal }}</p>
            <p class="mb-1"><strong>PAX:</strong> {{ resumen.pAdultos }}</p>
            <p class="mb-1"><strong>CHD:</strong> {{ resumen.pNinos }}</p>
          </div>
          <div class="col-lg-4">
            <p class="mb-1"><strong>Español:</strong> {{ resumen.espanol }}</p>
            <p class="mb-1"><strong>Inglés:</strong> {{ resumen.ingles }}</p>
          </div>
        </div>
      </ui-card>
      <Card body-class="p-0" :title="'Biblias'" icon="fa fa-fw fa-book">
        <template #toolbar>
          <router-link :to="{ name: 'biblias.registros.nuevo' }" class="btn btn-sm btn-primary shadow pulse-primary">
            Nuevo
          </router-link>
          <button class="btn btn-sm btn-outline-secondary ml-2" :disabled="loading.reporte || !paginacion.total" @click="onClickImprimir">
            {{ loading.reporte ? "Preparando..." : "Imprimir" }}
          </button>
        </template>
        <Table :rows="biblias" :columns="containers.tableColumns" :columnID="'idBiblia'" table-class="table-hover">
          <template #rowactions="{ row }">
            <router-link
              :to="{
                name: 'biblias.registros',
                params: { id: row.idBiblia },
              }"
              class="btn btn-icon btn-xs btn-light-primary mr-1"
            >
              <span class="far fa-fw fa-eye"></span>
            </router-link>
            <button class="btn btn-icon btn-xs btn-light-danger" @click="onClickDelete(row)">
              <span class="far fa-fw fa-trash-alt"></span>
            </button>
          </template>
          <template #rowfecha="{ val }">
            {{ val | date }}
          </template>
          <template #rowordenes="{ row, val }">
            <router-link
              v-if="val > 0"
              :to="{
                name: 'ordenes',
                query: { servicio: row.servicio, fecha: row.fecha },
              }"
              class="font-weight-bolder text-underline"
            >
              <u>
                {{ val }}
              </u>
            </router-link>
            <span v-else>{{ val }}</span>
          </template>
        </Table>
        <BPagination
          v-if="paginacion.total > paginacion.porPagina"
          :value="paginacion.pagina"
          :total-rows="paginacion.total"
          :per-page="paginacion.porPagina"
          :disabled="loading.biblias"
          first-number
          last-number
          :limit="6"
          align="center"
          class="mt-5"
          @input="onCambiarPagina"
        ></BPagination>
      </Card>
    </template>
  </ui-content>
</template>
<script>
import { BPagination } from "bootstrap-vue";

import Spinner from "../../shared/components/Spinner.vue";
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import Table from "../../shared/components/Table.vue";
import Card from "../../shared/components/Card.vue";
import InputSelect from "../../shared/components/InputSelect.vue";
import { debounce } from "../../shared/helpers";
import biblia_pdf from "../pdf/biblia_pdf";
export default {
  components: {
    InputSelect,
    Card,
    Table,
    InputDatepicker,
    Spinner,
    BPagination,
  },
  data() {
    return {
      servicio: "Todos",
      fecha: "",
      estado: "Todos",
      biblias: [],
      serviciosFiltro: [],
      loading: {
        view: true,
        biblias: false,
        reporte: false,
      },
      paginacion: {
        pagina: 1,
        porPagina: 50,
        total: 0,
        ultimaPagina: 0,
      },
      resumen: {
        nroBiblias: 0,
        registros: 0,
        pendientes: 0,
        pAdultos: 0,
        pNinos: 0,
        pTotal: 0,
        espanol: 0,
        ingles: 0,
      },
      inicializado: false,
      solicitudBiblias: 0,
      // flags
      show: false,
      containers: {
        tableColumns: [
          {
            key: "actions",
            label: "",
            width: 60,
            row_class: "text-center",
            head_class: "text-center",
          },
          {
            key: "fecha",
            label: "Fecha",
            width: 55,
          },
          {
            key: "servicio",
            label: "Servicio",
            // minWidth: 150,
            width: {
              XS: 150,
              SM: 200,
              MD: 160,
              LG: 200,
            },
          },
          {
            key: "registros",
            label: "Registros",
            headClass: "tlf-w-70",
            row_class: "text-center",
            width: 60,
          },
          {
            key: "nroAdultos",
            label: "PAX",
            width: 40,
            row_class: "text-center",
          },
          {
            key: "nroNinos",
            label: "CHD",
            width: 40,
            row_class: "text-center",
          },
          {
            key: "espanol",
            label: "ESP",
            width: 40,
            row_class: "text-center",
          },
          {
            key: "ingles",
            label: "ING",
            width: 40,
            row_class: "text-center",
          },
          {
            key: "pendiente",
            label: "PEND",
            width: 40,
            row_class: "text-center",
          },
          {
            key: "confirmado",
            label: "CONF",
            width: 40,
            row_class: "text-center",
          },
          {
            key: "vehiculo",
            label: "Vehículo",
            width: 150,
            row_class: "text-center",
          },
          {
            key: "guia",
            label: "Guía",
            width: 150,
          },
          {
            key: "ordenes",
            label: "Ordenes",
            width: 60,
            row_class: "text-center",
          },
          {
            key: "usuarioCreador",
            label: "UC",
            width: 70,
            row_class: "text-center text-truncate",
          },
          {
            key: "usuarioModificador",
            label: "UM",
            width: 70,
            row_class: "text-center text-truncate",
          },
        ],
      },
    };
  },
  async created() {
    try {
      await this.cargarFiltros();
      await this.cargarBiblias();
    } catch (error) {
      console.error(error?.response || error);
    } finally {
      this.inicializado = true;
      this.loading.view = false;
    }
  },
  computed: {
    servicios() {
      return ["Todos", ...this.serviciosFiltro.map((item) => item.nombre)];
    },
    estados() {
      return ["Todos", "Pendiente", "Confirmado"];
    },
  },
  watch: {
    servicio() {
      this.onFiltroModificado();
    },
    fecha() {
      this.onFiltroModificado();
    },
    estado() {
      this.onFiltroModificado();
    },
  },
  methods: {
    async cargarFiltros() {
      const response = await this.axios.get("/biblias/filtros");
      this.serviciosFiltro = response.data.content.serviciosFiltro;
    },
    parametrosFiltros(filtros = null) {
      const valores = filtros || {
        servicio: this.servicio,
        fecha: this.fecha,
        estado: this.estado,
      };
      const parametros = {};
      const servicio = this.serviciosFiltro.find((item) => item.nombre == valores.servicio);

      if (servicio) {
        parametros.idServicio = servicio.idServicio;
      }

      if (valores.fecha) {
        parametros.fecha = valores.fecha;
      }

      if (valores.estado && valores.estado != "Todos") {
        parametros.estado = valores.estado;
      }

      return parametros;
    },
    parametrosBiblias() {
      return {
        ...this.parametrosFiltros(),
        pagina: this.paginacion.pagina,
        porPagina: this.paginacion.porPagina,
      };
    },
    async cargarBiblias() {
      const solicitud = ++this.solicitudBiblias;
      this.loading.biblias = true;

      try {
        const response = await this.axios.get("/biblias", {
          params: this.parametrosBiblias(),
        });

        if (solicitud !== this.solicitudBiblias) return;

        const biblias = response.data.content;
        const paginacion = response.data.paginacion;

        if (!biblias.length && this.paginacion.pagina > 1 && paginacion.ultimaPagina < this.paginacion.pagina) {
          this.paginacion.pagina = Math.max(1, paginacion.ultimaPagina);
          await this.cargarBiblias();
          return;
        }

        this.biblias = biblias;
        this.paginacion = paginacion;
        this.resumen = response.data.resumen;
      } catch (error) {
        if (solicitud === this.solicitudBiblias) {
          console.error(error?.response || error);
        }
      } finally {
        if (solicitud === this.solicitudBiblias) {
          this.loading.biblias = false;
        }
      }
    },
    onFiltroModificado() {
      if (!this.inicializado) return;

      this.solicitudBiblias += 1;
      this.onCambiarFiltros();
    },
    onCambiarFiltros: debounce(function() {
      this.paginacion.pagina = 1;
      this.cargarBiblias();
    }, 400),
    onCambiarPagina(pagina) {
      if (pagina === this.paginacion.pagina) return;

      this.paginacion.pagina = pagina;
      this.cargarBiblias();
    },
    async onClickDelete(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire("", "¿Seguro que desea eliminar este item?");

      if (response.value) {
        try {
          response = await vm.axios.delete(`/biblias/${pItem.idBiblia}`);
          vm.$toast.fire(response.data.message, "", "success");
          await vm.cargarBiblias();
        } catch (error) {
          console.error(error);
          vm.$toast.fire(error?.response?.data?.message || "No fue posible eliminar la biblia", "", "error");
        }
      }
    },
    async onClickImprimir() {
      if (this.loading.reporte || !this.paginacion.total) return;

      const filtros = {
        servicio: this.servicio,
        fecha: this.fecha,
        estado: this.estado,
      };

      this.loading.reporte = true;

      try {
        const response = await this.axios.get("/biblias/reporte", {
          params: this.parametrosFiltros(filtros),
        });
        const bibliasReporte = response.data.content;

        if (!bibliasReporte.length) {
          this.$toast.fire("", "No hay biblias para imprimir", "warning");
          return;
        }

        const biblias = bibliasReporte.map((item) => ({
          ...item,
          fecha: item.fecha ? this.$dayjs(item.fecha).format("DD-MM-YY") : "",
        }));

        biblia_pdf({
          biblias,
          resumen: response.data.resumen,
          servicio: filtros.servicio,
          fecha: filtros.fecha,
          estado: filtros.estado,
          userMark: this.$store.state.user,
          dateMark: this.$dayjs().format("DD-MM-YY HH:mm"),
        });
      } catch (error) {
        console.error(error?.response || error);
        this.$toast.fire("", error?.response?.data?.message || "No fue posible preparar el reporte", "error");
      } finally {
        this.loading.reporte = false;
      }
    },
  },
};
</script>
